var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatString = exports.getMessage = exports.setLocaleForNotificationsCore = exports.messageMap = void 0;
var fast_memoize_1 = __importDefault(require("fast-memoize"));
var intl_messageformat_1 = require("intl-messageformat");
var TabLoc = __importStar(require("../../gen-src/Localize"));
var deMessages = __importStar(require("../messages/de_DE.json"));
var enGBMessages = __importStar(require("../messages/en_GB.json"));
var enUSMessages = __importStar(require("../messages/en_US.json"));
var esMessages = __importStar(require("../messages/es_ES.json"));
var frMessages = __importStar(require("../messages/fr_FR.json"));
var itMessages = __importStar(require("../messages/it_IT.json"));
var jaMessages = __importStar(require("../messages/ja_JP.json"));
var koMessages = __importStar(require("../messages/ko_KR.json"));
var ptMessages = __importStar(require("../messages/pt_BR.json"));
var zhsMessages = __importStar(require("../messages/zh_CN.json"));
var zhtMessages = __importStar(require("../messages/zh_TW.json"));
var localMessageMap = (_a = {},
    _a['en_GB'] = postProcessMessages(enGBMessages),
    _a['en_US'] = postProcessMessages(enUSMessages),
    _a['de_DE'] = postProcessMessages(deMessages),
    _a['es_ES'] = postProcessMessages(esMessages),
    _a['fr_FR'] = postProcessMessages(frMessages),
    _a['it_IT'] = postProcessMessages(itMessages),
    _a['ja_JP'] = postProcessMessages(jaMessages),
    _a['ko_KR'] = postProcessMessages(koMessages),
    _a['pt_BR'] = postProcessMessages(ptMessages),
    _a['zh_CN'] = postProcessMessages(zhsMessages),
    _a['zh_TW'] = postProcessMessages(zhtMessages),
    _a);
var fallbackLocale = 'en_US';
var messageLocaleForIntlMessageFormat;
var memoizedIntlMessageFormatOptions;
function setLocaleForNotificationsCore(messageLocale, getLocalizeFormatOverride) {
    exports.messageMap = localMessageMap[messageLocale] || localMessageMap[fallbackLocale];
    if (getLocalizeFormatOverride) {
        TabLoc.getLocalizeFormat = getLocalizeFormatOverride;
    }
    messageLocaleForIntlMessageFormat = (messageLocale || fallbackLocale).replace('_', '-');
    memoizedIntlMessageFormatOptions = {
        formatters: {
            getNumberFormat: fast_memoize_1.default(function (locale, opts) { return new Intl.NumberFormat(locale, opts); }),
            getDateTimeFormat: fast_memoize_1.default(function (locale, opts) { return new Intl.DateTimeFormat(locale, opts); }),
            getPluralRules: fast_memoize_1.default(function (locale, opts) { return new Intl.PluralRules(locale, opts); }),
        },
    };
}
exports.setLocaleForNotificationsCore = setLocaleForNotificationsCore;
exports.getMessage = function (messageId) {
    return exports.messageMap[messageId] || localMessageMap[fallbackLocale][messageId] || 'LOCERR_' + messageId;
};
function postProcessMessages(messages) {
    if (typeof messages.records !== 'undefined') {
        Object.keys(messages.records).forEach(function (key) {
            messages[messages.records[key].id] = messages.records[key].message;
        });
        messages.records = null;
    }
    else {
        Object.keys(messages).forEach(function (key) {
            var message = messages[key];
            if (typeof message !== 'string') {
                messages[key] = message.message;
            }
        });
    }
    return messages;
}
function formatString(str, args) {
    try {
        var formatter = new intl_messageformat_1.IntlMessageFormat(str, messageLocaleForIntlMessageFormat, undefined, memoizedIntlMessageFormatOptions);
        return formatter.format(args);
    }
    catch (e) {
        if (typeof __DEV__ !== 'undefined' && __DEV__) {
            throw e;
        }
        else {
            return '';
        }
    }
}
exports.formatString = formatString;
//# sourceMappingURL=localization.js.map